import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { isEmpty } from 'lodash';

import * as _actionsCheckout from '../../actions/checkout';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsJourney from '../../actions/journey1';
import { Button, EButtonType, Input } from '@repo/apg-ui';
import './Summary.scss';
import * as actions from '../../actions/index';
import { RootState } from '../../reducers';
import SpinnerV2 from '../../components/SpinnerV2';
import { isProd } from '../../constants/config';
import { TypeContainer } from '../../actions/typeContainer';
import { getPathname } from '../../utils/paths';
import { clearPaymentJourney, setPaymentJourney, trackJourneyCompleted } from '../../utils/journeyTracking';

import { ReactComponent as VisaIcon } from '../../assets/icons/visa.svg';
import { ReactComponent as MastercardIcon } from '../../assets/icons/mastercard.svg';
import { ReactComponent as EfinanceIcon } from '../../assets/icons/efinance.svg';
import { ReactComponent as PaypalIcon } from '../../assets/icons/paypal.svg';
import { ReactComponent as TwintIcon } from '../../assets/icons/twint.svg';
import { ReactComponent as RechnungIcon } from '../../assets/icons/rechnung.svg';
import { ReactComponent as VorausrechnungIcon } from '../../assets/icons/pub_e_i_rechnung.svg';
import { ReactComponent as PostFinanceIcon } from '../../assets/icons/pf_efinance_icon.svg';
import { ReactComponent as PostFinanceCardIcon } from '../../assets/icons/pf_e_i_postfinance_die_post.svg';
import { withRouter } from '../../utils/withRouter';
import BottomNavigation from '../../components/BottomNavigation';
import classNames from 'classnames';
import { formatNumber } from '../../utils/react';
import { getParameterByName } from '../../utils/toSearchParams';
import { useNavigate } from 'react-router';
import { useMedia } from 'react-use';
import { triggerDynamicsOnLoginArea } from '../../utils/reloadDynamics';
import {
  SchemaGetBookBastetQueryParams,
  SchemaPostCustomerDataRequestBody,
  SchemaPostStartPaymentProcessRequestBody,
  SchemaPostStopPaymentProcessRequestBody,
} from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  actionsCheckout: typeof _actionsCheckout;
  actionsJourney: typeof _actionsJourney;
  actionsBasket: typeof _actionsBasket;
  intl: any;
  journey2?: boolean;
  isAgencyCheckout?: boolean;
  locales: any;
  possibleBookingDates: any;
  industriesByKey: any;
  postProposals: any;
  proposals: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
  big5Industries: any;
  industry: any;
  loading: any;
  errors: any;
  router: any;
  dispatch: any;
  containers: TypeContainer;
  selectedCustomer: any;
}

export const TITLES_BY_CATEGORY = {
  1: <FormattedMessage id='ec.summary.zahlung' defaultMessage='Zahlung' />,
  2: <FormattedMessage id='ec.summary.richofferte' defaultMessage='Richtofferte' />,
  3: <FormattedMessage id='ec.summary.offerte' defaultMessage='Offertenübersicht' />,
};

// export const TITLES_BY_CATEGORY_FN = {
//     1: { id: 'ec.navigation.payment', defaultMessage: 'Zahlung' },
//     2: { id: 'ec.navigation.richofferte', defaultMessage: 'Richtofferte' },
//     3: { id: 'ec.navigation.offerte', defaultMessage: 'Offertenübersicht' },
// };

const ADDRESS_BY_CATEGORY = {
  1: <FormattedMessage id='ec.summary.invoiceAddress' defaultMessage='Rechnungsadresse' />,
  2: <FormattedMessage id='ec.summary.invoiceAddressRichOfferte' defaultMessage='Richtofferte für Kunde' />,
  3: <FormattedMessage id='ec.summary.invoiceAddressOfferte' defaultMessage='Offerte für Kunde' />,
};

// const PAYMENT_TITLE_BY_CATEGORY = {
//     1: <FormattedMessage id="ec.summary.choosePaymentMethod" defaultMessage="Zahlungsart wählen" />,
//     2: <FormattedMessage id="ec.summary.choosePaymentMethodRichOfferte" defaultMessage="Richtofferte erzeugen" />,
//     3: <FormattedMessage id="ec.summary.choosePaymentMethodOfferte" defaultMessage="Offerte reservieren" />,
// };
//
// const BUTTON_LABEL_BY_CATEGORY = {
//     1: <FormattedMessage id="ec.components.buttons.bookNow" defaultMessage="Jetzt buchen" />,
//     2: <FormattedMessage id="ec.components.buttons.bookNowRichtofferte" defaultMessage="Richtofferte erzeugen" />,
//     3: <FormattedMessage id="ec.components.buttons.bookNowOfferte" defaultMessage="Offerte reservieren" />,
// };

const PAYMENT_NOTE_BY_CATEGORY = {
  1: (
    <FormattedMessage
      id='ec.summary.pleaseChoosePaymentMethod'
      defaultMessage='Bitte wählen Sie aus folgenden Zahlungsmöglichkeiten aus:'
    />
  ),
  2: (
    <FormattedMessage
      id='ec.summary.pleaseChoosePaymentMethodOfferte'
      defaultMessage='Mit dem bestätigen der AGB und dem anschliessenden Klick auf den Button "Richtofferte erzeugen" wird keine Kampagne gebucht sowie auch keine Flächen für Sie reserviert. Die Richtofferte dient lediglich als Kostenübersicht zum aktuellen Zeitpunkt. Preisänderungen sind vorbehalten. Die Richtofferte finden Sie jeweils im Dashboard unter "Übersicht Richtofferten".'
    />
  ),
};

const Summary = (props: Props) => {
  const [paymentInProgress, setPaymentInProgress] = useState(false);
  const [voucherCode, setVoucherCode] = useState('');
  const [agbChecked, setAgbChecked] = useState(false);
  const [paymentOption, setPaymentOption] = useState(null);
  const [isCampaignEditMode, setIsCampaignEditMode] = useState(true);
  const [isCampaignPreReservationMode, setIsCampaignPreReservationMode] = useState(true);
  const [isBasketLoading, setIsBasketLoading] = useState(false);
  const isMobile = useMedia('(max-width: 768px)');

  const navigate = useNavigate();

  const {
    userDataEC: { basketInfo, vouchers, userInfo, campaignName },
    actionsCheckout,
    isAgencyCheckout,
    router,
    intl,
    loading: { voucher },
  } = props;

  const basketId: number = Number(getParameterByName('basketId', router.location.search));

  const icons = {
    /*
            1 - advance payment ("Vorausrechnung")
            2 - invoice ("Rechnung")
            3 - Visa
            4 - Mastercard
            5 - PPaypal
            6 - Postfinance Card
            7 - Postfinance e-finance
        */
    1: <VorausrechnungIcon />,
    2: <RechnungIcon />,
    3: <VisaIcon />,
    4: <MastercardIcon />,
    5: <PaypalIcon />,
    6: <PostFinanceCardIcon />,
    7: <PostFinanceIcon />,
    8: <TwintIcon />,
  };

  useEffect(() => {
    const {
      userDataEC: { basketInfo, chosenProposal },
      journey2,
      actionsCheckout,
      router,
    } = props;

    document.body.classList.add('step8');

    // Back on the summary means a started payment was cancelled, declined or abandoned, so it must never be tracked.
    clearPaymentJourney();

    if (basketInfo || chosenProposal?.basket || basketId) {
      fetchBasketInfo();
    } else {
      console.warn('Your basket is missing, probably because your session expired. Will redirect to step1');
      navigate(`/${journey2 || isAgencyCheckout ? 'journey2' : 'journey1'}/6`);
    }

    let paymentDeclinePayload = '';

    if (props.router.location.search) {
      paymentDeclinePayload = props.router.location.search + '&basket=' + basket;
    } else {
      paymentDeclinePayload = '?basket=' + basket;
    }

    if (router.location.state?.referrer.includes('checkout/cancel')) {
      actionsCheckout.getPostfinanceCancel(paymentDeclinePayload);
    } else if (router.location.state?.referrer.includes('checkout/decline')) {
      actionsCheckout.getPostfinanceDecline(paymentDeclinePayload);
    } else if (router.location.state?.referrer.includes('checkout/exception')) {
      actionsCheckout.getPostfinanceException(paymentDeclinePayload);
    }

    return () => {
      document.body.classList.remove('step8');
    };
  }, []);

  useEffect(() => {
    if (userInfo?.email && isProd) {
      triggerDynamicsOnLoginArea('summary', userInfo.email);
    }
  }, [userInfo]);

  const fetchBasketInfo = () => {
    const {
      userDataEC: { basketInfo, chosenProposal },
      journey2,
      isAgencyCheckout,
      actionsCheckout,
      actionsJourney,
      actionsBasket,
      errors,
    } = props;

    if (!isEmpty(errors)) {
      return;
    }

    if (journey2 && !isAgencyCheckout && basketInfo && !basketId) {
      actionsBasket
        .fetchBasketInfo({
          basket: basketInfo.basket,
          basketreference: basketInfo['basketreference'] || null,
        })
        .then((res: { name: any; campaign: any; state: number }) => {
          if (res?.name) {
            actionsCheckout.setCampaignName(res.name);
          }
          if (!res) {
            navigate('/journey2/1');
          } else if (res.name && res.campaign) {
            if (res.state === 0 || !res.campaign) {
              setIsCampaignEditMode(true);
            } else {
              setIsCampaignEditMode(false);
              actionsCheckout.fetchPaymentMethods({ basket: basketInfo.basket });
            }
          }
        });

      actionsJourney.getUserInfo();
    } else if (isAgencyCheckout && basketId) {
      actionsBasket
        .fetchBasketInfo({
          basket: basketId,
        })
        .then((res: { name: any; campaign: any }) => {
          if (res?.name) {
            actionsCheckout.setCampaignName(res.name);
          }
          if (!res) {
            navigate('/journey2/1');
          } else if (res.name && res.campaign) {
            setIsCampaignEditMode(false);
            actionsCheckout.fetchPaymentMethods({ basket: basketId });
          }
        });

      actionsJourney.getUserInfo();
    } else if (chosenProposal?.basket) {
      actionsBasket.fetchBasketInfo({
        basket: chosenProposal.basket,
        basketreference: chosenProposal['basketreference'],
      });

      actionsJourney.getUserInfo();
      actionsCheckout.fetchPaymentMethods({ basket: chosenProposal.basket });
    }
  };

  const postBasketCustomer = (clearData?: boolean) => {
    let payload: SchemaPostCustomerDataRequestBody = { basket: getBasketNumber() };
    const { firstname, name, street, nr, zipcode, city, gender } = userInfo;

    if (!clearData) {
      payload = {
        ...payload,
        title: gender,
        companyname: '',
        firstname,
        surname: name,
        street: `${street} ${nr}`.trim(),
        city,
        zipcode,
      };
    }

    return props.actionsCheckout.postCustomerData(payload);
  };

  const getBasketNumber = () => {
    const {
      userDataEC: { basketInfo, chosenProposal },
      journey2,
      isAgencyCheckout,
    } = props;

    return journey2 || isAgencyCheckout ? basketInfo?.basket : chosenProposal.basket;
  };

  const cancelBasket = () => {
    if (isAgencyCheckout) {
      if (props.userDataEC.basketInfo) {
        props.actionsJourney
          .getBasketState({
            basket: props.userDataEC.basketInfo.basket,
            basketreference: props.userDataEC.basketInfo.basketreference || '',
            autocancel: 1,
          })
          .then(() => {
            window.location.href = 'https://agency.ecom.apgsga.ch/import';
          })
          .catch((err) => {
            console.error(err);
            window.location.href = 'https://agency.ecom.apgsga.ch/import';
          });
      }
    }
  };

  const handleNextStep = () => {
    setPaymentInProgress(true);
    postBasketCustomer(true).then(payment);
  };

  const payment = () => {
    const {
      actionsCheckout,
      userDataEC: { paymentMethodsObj },
      journey2,
      isAgencyCheckout,
    } = props;

    if (paymentOption) {
      const paymentObj = paymentMethodsObj[paymentOption];

      const paymentPayload:
        | SchemaPostStartPaymentProcessRequestBody
        | SchemaPostStopPaymentProcessRequestBody
        | SchemaGetBookBastetQueryParams = {
        basket: getBasketNumber(),
        paymentid: paymentObj.id,
      };

      const parameters = paymentObj.params ? new URLSearchParams(paymentObj.params) : null;

      if (paymentObj.params.ACCEPTURL) {
        const paymentUrl = `https://${paymentObj.url}?${parameters.toString()}`;

        actionsCheckout
          .startPaymentProcess(paymentPayload)
          .then((res: { notices: { code: number }[]; data: { paymenturl: string } }) => {
            if (res?.notices[0]?.code === 1) {
              actionsCheckout.stopPaymentProcess(paymentPayload).catch((err: any) => console.error('error: ', err));
            } else if (res.data.paymenturl) {
              setPaymentJourney(props.router.location.pathname);
              window.location.href = res.data.paymenturl;
            } else {
              setPaymentJourney(props.router.location.pathname);
              window.location.href = paymentUrl;
            }
          })
          .catch((err: any) => {
            console.error('error: ', err);
            actionsCheckout.stopPaymentProcess(paymentPayload).catch((err: any) => console.error('error: ', err));
          })
          .finally(() => setPaymentInProgress(false));
      } else {
        actionsCheckout
          .getBookBasket(paymentPayload)
          .then((res: { data?: { campaign?: string } }) => {
            if (res?.data) {
              trackJourneyCompleted(props.router.location.pathname, res.data.campaign);
            }
            if (isAgencyCheckout) {
              navigate('/journey2/6');
            } else {
              navigate(journey2 ? getPathname(props.containers)(6) : '/journey1/9');
            }
          })
          .catch((err: any) => console.error('error: ', err))
          .finally(() => setPaymentInProgress(false));
      }
    } else {
      if (isAgencyCheckout) {
        navigate('/journey2/6');
      } else {
        navigate(journey2 ? getPathname(props.containers)(6) : '/journey1/9');
      }
    }
  };

  const preparePaymentOptions = () => {
    if (props.userDataEC.paymentMethods) {
      return props.userDataEC.paymentMethods.map(({ name, id }) => {
        // const icons = this.icons;

        return {
          label: name,
          type: 'radio',
          name: 'address',
          value: name,
          icon: icons[id] ? icons[id] : <EfinanceIcon />,
          onChange: (_: any, _paymentOption: any) => setPaymentOption(_paymentOption),
        };
      });
    }

    return [];
  };

  const isAgency = () => {
    return props.userDataEC.userInfo ? props.userDataEC.userInfo.role === 4 : false;
  };

  const getIndustryValue = () => {
    const {
      industriesByKey,
      big5Industries,
      userDataEC: { industry, basketInfo },
    } = props;
    let selectedIndustry: string;

    if (basketInfo.industry) {
      selectedIndustry = basketInfo.industry.name;
    } else if (industriesByKey && industriesByKey[industry]) {
      selectedIndustry = industriesByKey[industry].value;
    } else if (big5Industries && big5Industries[industry]) {
      selectedIndustry = big5Industries[industry].value;
    }

    if (selectedIndustry !== 'Autohändler/Garagen') {
      return selectedIndustry;
    } else {
      return 'Keines dieser Themen';
    }
  };

  const getRichOffertePaymentText = () => {
    return (
      <FormattedMessage
        id='ec.summary.pleaseChoosePaymentMethodRichofferte'
        defaultMessage='Mit dem bestätigen der AGB und dem anschliessenden Klicken auf den Button
            "Offerte reservieren" wird für Sie die Kampagne je nach Aushang 7 bis 21 Tage bei uns im System reserviert.
            Nach Ablauf der Frist wird die Reservation wieder aufgehoben.
            Die Offerte finden Sie jeweils im Dashboard unter "Übersicht Offerten".'
        values={{ days: props.userDataEC.basketInfo.reserveddays || 14 }}
      />
    );
  };

  const paymentOptions = preparePaymentOptions();
  const basket = getBasketNumber();

  const saveBasketData = () => {
    const {
      userDataEC: { basketInfo, chosenProposal },
      actionsBasket: { postBasketData },
      journey2,
      isAgencyCheckout,
    } = props;

    const payload = {
      basket: journey2 || isAgencyCheckout ? basketInfo?.basket : chosenProposal?.basket,
      basketreference: journey2 || isAgencyCheckout ? basketInfo.basketreference : chosenProposal.basketreference,
      name: campaignName,
    };

    setIsBasketLoading(true);

    postBasketData(payload).then(() => {
      reserveBasket(voucherCode);
    });
  };

  const reserveBasket = (voucherCode?: string) => {
    const {
      userDataEC: { basketInfo, chosenProposal },
      actionsCheckout: { postReserveBasket, fetchPaymentMethods },
      actionsBasket,
      isAgencyCheckout,
      journey2,
    } = props;
    let payload = {
      basket: journey2 || isAgencyCheckout ? basketInfo.basket : chosenProposal.basket,
      basketreference:
        journey2 || isAgencyCheckout ? basketInfo.basketreference || null : chosenProposal.basketreference,
    };

    if (props.selectedCustomer) {
      payload['customer'] = props.selectedCustomer.customerid;
    }

    if (voucherCode) {
      payload['vouchercode'] = voucherCode;
    }

    return postReserveBasket(payload).then((result: { data: { campaign: string } }) => {
      if (result) {
        if (result.data && result.data.campaign) {
          setIsCampaignPreReservationMode(false);
          fetchPaymentMethods({ basket: basketInfo.basket }).then(() => {
            actionsBasket.getBasketContent(payload);
            actionsBasket.fetchBasketInfo(payload).then(() => {
              setIsCampaignEditMode(false);
              setIsBasketLoading(false);
              actionsCheckout.setIsBasketBooked(true);
            });
          });
        } else {
          actionsBasket.fetchBasketInfo(payload).then(() => {
            setIsBasketLoading(false);
          });
        }
        setVoucherCode('');
      } else {
        actionsBasket.fetchBasketInfo(payload).then(() => {
          setIsBasketLoading(false);
        });
      }
    });
  };

  const renderTotal = () => {
    const basketInfo = props.userDataEC.basketInfo;

    return basketInfo ? (
      <div className='total'>
        <h3 className='fw-bold mb-4'>
          <FormattedMessage id='faq.totalSum' defaultMessage='Gesamtsumme' />
        </h3>

        <div className='d-flex justify-content-between mb-3 font-14'>
          <p className='fw-bold normal-text'>
            <FormattedMessage id='faq.totalBrutto' defaultMessage='Total Medialeistung brutto' />
          </p>

          <p className='fw-bold normal-text white-space-nowrap'>
            {props.loading.basket ? (
              <SpinnerV2 relative inText />
            ) : (
              basketInfo.mediasum && (
                <>
                  {` ${formatNumber(basketInfo.mediasum, 2)}`}&nbsp;
                  <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                </>
              )
            )}
          </p>
        </div>

        {basketInfo.discount !== 0 && (
          <div className='mb-3'>
            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column'>
                <p className='normal-text'>{basketInfo.discountlabel ? basketInfo.discountlabel : ''}</p>
                {basketInfo.discountsublabel && <p className='small-text'>{basketInfo.discountsublabel}</p>}
              </div>

              <p className='normal-text white-space-nowrap'>
                {basketInfo.discount && (
                  <>
                    {formatNumber(basketInfo.discount, 2)}&nbsp;
                    <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                  </>
                )}
              </p>
            </div>
          </div>
        )}

        <div className='d-flex justify-content-between mb-3'>
          <p className='fw-bold normal-text'>
            {basketInfo.agencyprovision && basketInfo.discount ? (
              <FormattedMessage id='faq.totalNetAgency' defaultMessage='Total netto' />
            ) : (
              <FormattedMessage id='faq.totalNet' defaultMessage='Total netto/netto' />
            )}
          </p>

          <p className='fw-bold normal-text white-space-nowrap'>
            {props.loading.basket ? (
              <SpinnerV2 relative inText />
            ) : basketInfo.mediasum ? (
              formatNumber(basketInfo.mediasum - basketInfo.discount, 2) + ' CHF'
            ) : (
              '?'
            )}
          </p>
        </div>

        {basketInfo.agencyprovision && (
          <div className='mb-3'>
            <div className='d-flex justify-content-between'>
              <div className='d-flex flex-column'>
                <p className='normal-text'>{basketInfo.provisionlabel ? basketInfo.provisionlabel : ''}</p>
                {basketInfo.provisionsublabel && <p className='small-text'>{basketInfo.provisionsublabel}</p>}
              </div>

              <p className='normal-text white-space-nowrap'>
                {basketInfo.agencyprovision && (
                  <>
                    {formatNumber(basketInfo.agencyprovision, 2)}&nbsp;
                    <FormattedMessage id='faq.chf' defaultMessage='CHF' />
                  </>
                )}
              </p>
            </div>
          </div>
        )}

        {basketInfo.agencyprovision && (
          <div className='d-flex justify-content-between mb-3'>
            <p className='fw-bold normal-text'>
              <FormattedMessage id='faq.totalNet' defaultMessage='Total netto/netto' />
            </p>

            <p className='fw-bold normal-text'>
              {props.loading.basket ? (
                <SpinnerV2 relative inText />
              ) : basketInfo.agencyprovision ? (
                formatNumber(
                  basketInfo.mediasum - basketInfo.agencyprovision - (basketInfo.discount ? basketInfo.discount : 0),
                  2,
                ) + ' CHF'
              ) : (
                '?'
              )}
            </p>
          </div>
        )}

        <div className='d-flex justify-content-between mb-3'>
          <p className='normal-text'>
            <FormattedMessage id='faq.mwst' defaultMessage='MwSt. ' />
          </p>

          <p className='normal-text white-space-nowrap'>
            {props.loading.basket ? (
              <SpinnerV2 relative inText />
            ) : basketInfo.tax ? (
              formatNumber(basketInfo.tax, 2) + ' CHF'
            ) : (
              '?'
            )}
          </p>
        </div>

        <div className='d-flex justify-content-between mb-3'>
          <div className='d-flex flex-column'>
            <p className='fw-bold normal-text'>
              <FormattedMessage id='faq.totalIncludingMwwst' defaultMessage='Total inkl. MwSt.' />
            </p>
          </div>

          <p className='fw-bold normal-text white-space-nowrap'>
            {props.loading.basket ? (
              <SpinnerV2 relative inText />
            ) : (
              <>
                {` ${formatNumber(basketInfo.totalsum, 2)}`}&nbsp;
                <FormattedMessage id='faq.chf' defaultMessage='CHF' />
              </>
            )}
          </p>
        </div>
      </div>
    ) : null;
  };

  // @ts-ignore
  return (
    <div className='summary row m-0'>
      {isMobile && <h4 className='title-journey w-100'>{TITLES_BY_CATEGORY[basketInfo.category]}</h4>}

      <div
        className={classNames(
          'campaign-title-wrapper d-flex flex-column flex-md-row justify-content-between bg-white',
          {
            'align-items-start': isCampaignEditMode,
            'align-items-center': !isCampaignEditMode,
          },
        )}
        style={{ marginBottom: '2px', borderBottom: '1px solid lightgray' }}
      >
        <div className='input-title w-100 w-md-50 mb-5 mb-md-0'>
          <div className='font-24 font-bold'>
            <FormattedMessage id='ec.checkout.inputNameHint' defaultMessage='Name der Werbekampagne' />
          </div>
          {!isCampaignEditMode && isMobile && (
            <Button buttonType={EButtonType.BasicLink} onClick={() => setIsCampaignEditMode(true)} className={'ps-24'}>
              <FormattedMessage id='ec.summary.change' defaultMessage='Ändern' />
            </Button>
          )}
        </div>
        <div className='d-flex w-100 w-md-50 flex-column'>
          <div className='d-flex align-items-center'>
            <Input
              value={campaignName}
              name={'address'}
              onChange={(_, value) => actionsCheckout.setCampaignName(value)}
              type='text'
              placeholder={intl.formatMessage({
                id: 'ec.checkout.inputNamePlaceholder',
                defaultMessage: 'Z. B. Digitale Kampagne März',
              })}
              inputWrapperClass='flex-grow-1 mt-0'
              disabled={!isCampaignEditMode}
            />
            {!isCampaignEditMode && !isMobile && (
              <Button
                buttonType={EButtonType.BasicLink}
                onClick={() => setIsCampaignEditMode(true)}
                className={'ps-24'}
              >
                <FormattedMessage id='ec.summary.change' defaultMessage='Ändern' />
              </Button>
            )}
          </div>
          {isCampaignEditMode && !isCampaignPreReservationMode && (
            <div className='d-flex align-items-start justify-content-between gap-3 w-100'>
              {isMobile && (
                <Button
                  className={'w-50'}
                  buttonType={EButtonType.InvertedPillMedium}
                  onClick={() => {
                    setIsCampaignEditMode(false);
                  }}
                  isDisabled={!campaignName || isBasketLoading}
                >
                  <FormattedMessage id='ec.components.buttons.zuruck' defaultMessage='Zurück' />
                </Button>
              )}

              <Button
                className={isMobile ? 'w-50' : 'w-100'}
                buttonType={EButtonType.PillMedium}
                onClick={() => saveBasketData()}
                isDisabled={!campaignName || isBasketLoading}
              >
                {!isBasketLoading ? (
                  <FormattedMessage id='ec.summary.confirm' defaultMessage='Speichern' />
                ) : (
                  <SpinnerV2 relative />
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
      {isCampaignEditMode && isCampaignPreReservationMode && (
        <div
          className={classNames(
            'campaign-title-wrapper d-flex flex-column flex-md-row justify-content-between bg-white',
            {
              'align-items-start': isCampaignEditMode,
              'align-items-center': !isCampaignEditMode,
            },
          )}
          style={{ marginTop: '0px', paddingTop: '20px' }}
        >
          <div className='input-title w-100 w-md-50 mb-5 mb-md-0'>
            <div className='font-24 font-bold'></div>
          </div>
          <div className='d-flex w-100 w-md-50 flex-column'>
            <div className='font-16 text-grey' style={{ marginBottom: '10px' }}>
              <FormattedMessage id='ec.summary.gutscheinQuestion' defaultMessage='Haben Sie einen Gutschein?' />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                value={voucherCode}
                name={'address'}
                onChange={(_, value) => setVoucherCode(value)}
                type='text'
                placeholder={intl.formatMessage({
                  id: 'ec.checkout.voucherCode',
                  defaultMessage: 'Gutschein-Nr.',
                })}
                inputWrapperClass='flex-grow-1 mt-0'
                disabled={!isCampaignEditMode}
              />
            </div>
            {isCampaignEditMode && (
              <div className='d-flex align-items-start justify-content-between gap-3 w-100'>
                {isMobile && (
                  <Button
                    className={'w-50'}
                    buttonType={EButtonType.InvertedPillMedium}
                    onClick={() => {
                      setIsCampaignEditMode(false);
                    }}
                    isDisabled={!campaignName || isBasketLoading}
                  >
                    <FormattedMessage id='ec.components.buttons.zuruck' defaultMessage='Zurück' />
                  </Button>
                )}

                <Button
                  className={isMobile ? 'w-50' : 'w-100'}
                  buttonType={EButtonType.PillMedium}
                  onClick={() => saveBasketData()}
                  isDisabled={!campaignName || isBasketLoading}
                >
                  {!isBasketLoading ? (
                    <FormattedMessage id='ec.summary.confirm' defaultMessage='Speichern' />
                  ) : (
                    <SpinnerV2 relative />
                  )}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      {basketInfo ? (
        <div
          className={classNames('bg-white second-step-checkout d-flex flex-column flex-md-row w-100', {
            'semi-transparent': isCampaignEditMode,
          })}
        >
          <div className='d-flex flex-column address-details'>
            <div>
              <h3 className='mt-4 mb-4'>
                <FormattedMessage id='ec.checkout.plakatanlieferung' defaultMessage='Werbemittelanlieferung' />
              </h3>

              <div className='delivery-data'>
                {basketInfo.deliverydata &&
                  basketInfo.deliverydata.length > 0 &&
                  basketInfo.deliverydata.map(({ address, datetime, type, formatlabel, countformats }) => (
                    <div className='w-100 mb-4 font-16'>
                      <p className='fw-bold mb-3'>
                        {type === 'digital' && (
                          <FormattedMessage id='ec.checkout.anlieferungDigitalType' defaultMessage='Digital-Spots:' />
                        )}

                        {type === 'traffic' && (
                          <FormattedMessage id='ec.checkout.anlieferungTrafficType' defaultMessage='Hängekartons:' />
                        )}

                        {type === 'plakat' && (
                          <FormattedMessage id='ec.checkout.anlieferungPlakatType' defaultMessage='Plakate:' />
                        )}
                      </p>

                      <p className='color-text mb-1'>
                        <FormattedMessage
                          id='ec.checkout.anlieferungDate'
                          defaultMessage='{label} bis am {deliveryDate}'
                          values={{
                            label:
                              type === 'digital'
                                ? intl.formatMessage({
                                    id: 'ec.checkout.anlieferungDateDigitalLabel',
                                    defaultMessage: 'Hochladen der Spots',
                                  })
                                : intl.formatMessage({
                                    id: 'ec.checkout.anlieferungDateGeneralLabel',
                                    defaultMessage: 'Anlieferung',
                                  }),
                            deliveryDate: format(parseISO(datetime), 'dd.MM.yyyy', {
                              locale: de,
                            }),
                          }}
                        />
                      </p>

                      <p className='color-text'>
                        <FormattedMessage
                          id='ec.checkout.anlieferungsAddress'
                          defaultMessage='Anlieferungsadresse: {deliveryAddress}'
                          values={{ deliveryAddress: address }}
                        />
                      </p>

                      {formatlabel && <p className='fw-bold mb-3 mt-24'>{formatlabel}</p>}
                      {countformats && <p className='mb-3'>{countformats}</p>}
                    </div>
                  ))}
              </div>
            </div>

            <h3 className='mt-4 mb-4'>
              <FormattedMessage id='ec.checkout.summaryOfOrder' defaultMessage='Zusammenfassung Ihrer Bestellung' />
            </h3>

            <div className='d-flex align-items-start justify-content-between py-3 border-bottom border-grey-very-light font-14'>
              <div className='font-bold'>
                <FormattedMessage id='ec.summary.flachen' defaultMessage='Flächen' />
              </div>
              <div className='label-value padding-start text-end'>
                <span>{basketInfo.totalcount} </span>
                {basketInfo.countgroups &&
                  // @ts-expect-error OpenAPI spec type mismatch: Record<string, never>
                  basketInfo.countgroups.map((group: { count: any; name: any }, idx: any) => {
                    return <span key={`countGroup${idx}`}>{` | ${group.count} ${group.name}`}</span>;
                  })}
              </div>
            </div>

            <div className='d-flex align-items-start justify-content-between py-3 border-bottom border-grey-very-light font-14'>
              <div className='font-bold'>
                <FormattedMessage id='ec.summary.zeitraum' defaultMessage='Zeitraum' />
              </div>
              <div className='label-value padding-start text-end'>{basketInfo.date}</div>
            </div>

            <div className='d-flex align-items-start justify-content-between py-3 border-bottom border-grey-very-light font-14'>
              <div className='font-bold'>
                <FormattedMessage id='ec.summary.branche' defaultMessage='Branche' />
              </div>
              <div className='label-value padding-start text-end'>{getIndustryValue()}</div>
            </div>

            <div className='d-flex align-items-start justify-content-between py-3 font-14'>
              <div className='font-bold'>
                <FormattedMessage id='ec.summary.zielgebiet' defaultMessage='Zielgebiet' />
              </div>
              <div className='label-value padding-start text-end'>
                {basketInfo.regions &&
                  basketInfo.regions.map(
                    // @ts-expect-error name is not specified on OpenAPI Schema: Record<string, never>
                    (
                      region: {
                        name:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | React.ReactFragment
                          | React.ReactPortal;
                      },
                      idx: number,
                    ) => {
                      return <span key={`region-${idx}`}>{idx > 0 ? ` | ${region.name}` : region.name}</span>;
                    },
                  )}
              </div>
            </div>
          </div>

          <div className='d-flex flex-column payment-options'>
            <h3 className='my-4'>{ADDRESS_BY_CATEGORY[basketInfo.category]}</h3>
            <div className='d-flex font-14'>
              {userInfo &&
                basketInfo &&
                (basketInfo.agencycustomer ? (
                  <div className='w-100 px-0'>
                    {/* @ts-expect-error agencycustomer does not exist on OpenAPI Spec: */}
                    <p className='mb-1'>{basketInfo.agencycustomer.companyname}</p>
                    {/* @ts-expect-error agencycustomer does not exist on OpenAPI Spec: */}
                    <p className='mb-1'>{basketInfo.agencycustomer.street}</p>
                    <p className='mb-1'>
                      {/* @ts-expect-error agencycustomer does not exist on OpenAPI Spec: */}
                      {basketInfo.agencycustomer.zipcode} {basketInfo.agencycustomer.city}
                    </p>
                  </div>
                ) : (
                  <div className='w-100 px-0'>
                    {userInfo.company && <p className='mb-1'>{userInfo.company}</p>}
                    <p className='mb-1'>
                      {userInfo.firstname} {userInfo.lastname}
                    </p>
                    <p className='mb-1'>{userInfo.address}</p>
                    <p className='mb-1'>
                      {userInfo.zip} {userInfo.city}
                    </p>
                  </div>
                ))}
            </div>
            <h3 className='mt-24 mb-3'>
              <FormattedMessage id='ec.summary.choosePaymentMethod' defaultMessage='Zahlungsart wählen' />
            </h3>

            <p className='mb-4 sub-title'>
              {basketInfo.category === 3 ? getRichOffertePaymentText() : PAYMENT_NOTE_BY_CATEGORY[basketInfo.category]}
            </p>

            <Input
              readOnly={false}
              forcedValue={paymentOption}
              radioOptions={paymentOptions}
              inputWrapperClass='payments'
            />
            {!isCampaignEditMode && (
              <>
                <h3 className='mt-4 mb-3'>
                  <FormattedMessage id='ec.summary.gutschein' defaultMessage='Gutschein' />
                </h3>

                {(!vouchers || vouchers.length == 0) && (
                  <div className='gutschein'>
                    <p className='w-100 fw-bold sub-title'>
                      <FormattedMessage id='ec.summary.gutscheinQuestion' defaultMessage='Haben Sie einen Gutschein?' />
                    </p>

                    <form
                      className='d-flex w-100 flex-nowrap'
                      onSubmit={async (e) => {
                        e.preventDefault();
                        await props.actionsCheckout.postAddVoucher({
                          basket,
                          code: voucherCode,
                        });
                        fetchBasketInfo();
                      }}
                    >
                      <div className='px-0 w-100'>
                        <Input
                          value={voucherCode}
                          name={'address'}
                          required
                          onChange={(_, value) => setVoucherCode(value)}
                          type='text'
                          placeholder={intl.formatMessage({
                            id: 'ec.checkout.voucherCode',
                            defaultMessage: 'Gutschein-Nr.',
                          })}
                          inputWrapperClass='high px-0 mt-0'
                        />
                      </div>

                      <div className='d-flex align-items-end px-0'>
                        <Button
                          className='ms-24'
                          isDisabled={!voucherCode.trim() || voucher}
                          isLoading={voucher}
                          submit
                          buttonType={EButtonType.PillMedium}
                        >
                          <FormattedMessage id='ec.components.buttons.apply' defaultMessage='Anwenden' />
                        </Button>
                      </div>
                    </form>
                  </div>
                )}

                <div className='d-flex w-100 py-5' style={{ marginTop: '-40px', marginBottom: '20px' }}>
                  {vouchers &&
                    vouchers.map(
                      (singlevoucher: {
                        basket: any;
                        code:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                          | React.ReactFragment
                          | React.ReactPortal;
                      }) => {
                        if (basketInfo.basket === singlevoucher.basket) {
                          return (
                            <div className='mt-3 d-flex align-items-center'>
                              <div className='font-18 font-bold' style={{ paddingTop: '14px' }}>
                                {singlevoucher.code}
                              </div>
                              <div className='d-flex align-items-end ps-24 pe-0'>
                                <Button
                                  className='ms-24'
                                  isDisabled={voucher}
                                  isLoading={voucher}
                                  onClick={async () => {
                                    await props.actionsCheckout.postDeleteVoucher({
                                      basket,
                                      code: singlevoucher.code.toString(),
                                    });
                                    fetchBasketInfo();
                                  }}
                                  buttonType={EButtonType.PillMedium}
                                >
                                  <FormattedMessage id='ec.components.buttons.remove' defaultMessage='Entfernen' />
                                </Button>
                              </div>
                            </div>
                          );
                        }

                        return null;
                      },
                    )}
                </div>
              </>
            )}

            <div className='d-flex customCheckbox mb-4'>
              <input
                id='abg'
                name='abg'
                type='checkbox'
                checked={agbChecked}
                onChange={(e) => {
                  setAgbChecked(e.target.checked);
                }}
              />

              <label htmlFor='abg'>
                <a
                  rel='noopener noreferrer'
                  className='font-14'
                  target='_blank'
                  href={
                    isProd
                      ? intl.formatMessage({
                          id: 'ec.summary.agbLink',
                          defaultMessage: 'https://www.apgsga.ch/de/agb/',
                        })
                      : intl.formatMessage({
                          id: 'ec.summary.agbLinkStage',
                          defaultMessage: 'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/agb/',
                        })
                  }
                >
                  <FormattedMessage id='ec.summary.agbcheckbox' defaultMessage='AGB' />
                </a>
              </label>
            </div>

            <p className='mb-4 sub-title'>
              <FormattedMessage
                id='ec.summary.agbDescription'
                defaultMessage='Ich habe die Allgemeinen Geschäftsbedingungen der APG|SGA gelesen und erkläre mich damit einverstanden.'
              />
            </p>
            {!isCampaignEditMode && <div>{renderTotal()}</div>}
          </div>
        </div>
      ) : (
        <SpinnerV2 />
      )}
      <BottomNavigation
        isLoading={paymentInProgress}
        isAgencyCheckout={isAgencyCheckout}
        isReservation={basketInfo ? basketInfo.category === 3 : false}
        isSkipNextStep={isAgencyCheckout}
        isDisabled={paymentInProgress || !agbChecked || !paymentOption}
        total={formatNumber(basketInfo?.totalsum, 2)}
        nextCallback={handleNextStep}
        prevCallback={cancelBasket}
      />
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
    router: state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsCheckout: bindActionCreators(_actionsCheckout as any, dispatch),
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Summary)));
